import { render, staticRenderFns } from "./betRecord.vue?vue&type=template&id=652a6351&scoped=true"
import script from "./betRecord.vue?vue&type=script&lang=js"
export * from "./betRecord.vue?vue&type=script&lang=js"
import style0 from "./betRecord.vue?vue&type=style&index=0&id=652a6351&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a6351",
  null
  
)

export default component.exports